import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import React from 'react'

import * as audioActions from '../Game/AudioContainer/audio.actions'

const VOLUME_CHANGE_RATE = 0.02

/**
 *  Audio player.
 *  If ui prop is set to true, displays an user interface.
 */
class AudioPlayer extends React.Component {
  /**
   *  Component constructor.
   */
  constructor(props) {
    super(props)

    this.volumeUpFn = () => {
      this.volumeUp()
    }
    this.volumeDownFn = () => {
      this.volumeDown()
    }
  }
  /**
   *  Componen did mount.
   */
  componentDidMount() {
    const { ui, url, audioPosition } = this.props

    if (ui || !url) {
      return
    }

    const audio = new Audio()

    this.onCanPlayListener = () => {
      this.onCanPlay()
    }
    this.onEndedListener = () => {
      this.onEnded()
    }

    audio.addEventListener('canplay', this.onCanPlayListener)
    audio.addEventListener('ended', this.onEndedListener)
    audio.volume = 0
    audio.src = url
    if (!isNaN(audio.duration)) {
      audio.currentTime = audioPosition ? audioPosition : 0
    }
    this.audio = audio
    let audio2 = audio
    this.recursiveAdio(audio2)
  }
  recursiveAdio(audio) {
    audio.load()
  }
  /**
   *  Component will unmount.
   */
  componentWillUnmount() {
    const { ui } = this.props

    if (ui || !this.audio) {
      return
    }
    this.audio.pause()
    requestAnimationFrame(this.volumeDownFn)
    this.audio.removeEventListener('canplay', this.onCanPlayListener)
    this.audio.removeEventListener('ended', this.onEndedListener)
  }

  /**
   *  Fired when sound was loaded completely.
   */
  onCanPlay() {
    if (!this) {
      return
    }
    const { autoplay, duration, registerAudioPlaying } = this.props

    if (autoplay && this.audio.paused) {
      this.audio.play()
      registerAudioPlaying(this)
      requestAnimationFrame(this.volumeUpFn)
      duration
        ? setTimeout(() => {
            this.volumeDown()
          }, duration)
        : null
    }
  }

  /**
   *  Fired when the sound finish.
   */
  onEnded() {
    if (!this) {
      return
    }

    const { id, loop, removeAudio } = this.props

    if (loop && this.audio) {
      this.audio.play()
    } else {
      removeAudio(id)
    }
  }

  /**
   *  Volume down animation.
   */
  volumeDown() {
    if (!this || !this.audio) {
      return
    }

    const { volumeChangeRate = VOLUME_CHANGE_RATE } = this.props
    const volume = this.audio.volume - volumeChangeRate

    this.audio.volume = volume < 0 ? 0 : volume
    if (this.audio.volume > 0) {
      requestAnimationFrame(this.volumeDownFn)
    } else {
      this.audio.pause()
    }
  }

  /**
   *  Volume up animation.
   */
  volumeUp() {
    if (!this || !this.audio) {
      return
    }

    const { volumeChangeRate = VOLUME_CHANGE_RATE } = this.props
    const volume = this.audio.volume + volumeChangeRate

    this.audio.volume = volume > 1 ? 1 : volume
    if (this.audio.volume < 1) {
      requestAnimationFrame(this.volumeUpFn)
    }
  }

  /**
   *  Render audio with user interface.
   */
  render() {
    const { url, ui, type } = this.props
    let style = {}

    if (!url) {
      return null
    }
    if (!ui) {
      style = { height: 0, width: 0, visibility: 'hidden' }
    }

    return (
      <audio
        autoPlay
        loop={type === 'background' ? true : false}
        style={style}
        ref={(audio) => {
          this.audio = audio
        }}
        controls
      >
        <source src={url} />
      </audio>
    )
  }
}

AudioPlayer.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  audioPosition: PropTypes.number,
  autoplay: PropTypes.bool,
  duration: PropTypes.number,
  loop: PropTypes.bool,
  removeAudio: PropTypes.func,
  registerAudioPlaying: PropTypes.func,
  ui: PropTypes.bool,
  url: PropTypes.string.isRequired,
  volumeChangeRate: PropTypes.number,
}

const mapDispatchToProps = (dispatch) => {
  return {
    removeAudio: bindActionCreators(audioActions.removeAudio, dispatch),
    registerAudioPlaying: bindActionCreators(audioActions.registerAudioPlaying, dispatch),
  }
}

export default connect(null, mapDispatchToProps)(AudioPlayer)
